import { Grid, TextField } from '@mui/material'
import React, { FunctionComponent, useEffect } from 'react'
import { Controller, UseFormReturn, useWatch } from 'react-hook-form'

import { NumeroMask } from '../../../../base/components/Mask/NumeroMask'
import { InputCodigoMask } from '../../../../base/components/MyInputs/InputCodigoMask'
import { actionForm, ActionFormProps } from '../../../../interfaces'
import SinMonedaField from '../../components/SinMonedaField'
import { MonedaInputProps, MonedaProps } from '../../interfaces'

interface OwnProps {
  form: UseFormReturn<MonedaInputProps>
  action: ActionFormProps
  monedaPrimaria: MonedaProps | null
}

type Props = OwnProps

const MonedaForm: FunctionComponent<Props> = (props) => {
  const { form, action, monedaPrimaria } = props
  const {
    control,
    formState: { errors },
    setValue,
  } = form

  const sinMoneda = useWatch({ control, name: 'sinMoneda' })

  useEffect(() => {
    if (sinMoneda) {
      setValue('descripcion', `${sinMoneda.descripcion}`)
    }
  }, [sinMoneda])

  return (
    <>
      <Grid container rowSpacing={3} columnSpacing={2}>
        <Grid size={12}>
          <Controller
            name={'sinMoneda'}
            control={control}
            render={({ field }) => (
              <SinMonedaField
                inputRequired={true}
                inputDisabled={action === actionForm.UPDATE}
                isError={Boolean(errors.sinMoneda)}
                helperText={errors.sinMoneda?.message || ''}
                onInputChange={field.onChange}
                value={field.value}
              />
            )}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 4 }}>
          <Controller
            name={'sigla'}
            control={control}
            render={({ field }) => (
              <TextField
                label={'Sigla Moneda'}
                size={'small'}
                fullWidth
                onChange={field.onChange}
                value={field.value}
                helperText={errors.sigla?.message || ''}
                error={Boolean(errors.sigla)}
                required
                slotProps={{
                  input: {
                    inputComponent: InputCodigoMask as any,
                  },
                  inputLabel: { shrink: true },
                }}
                disabled={action === actionForm.UPDATE}
              />
            )}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 8 }}>
          <Controller
            name={'descripcion'}
            control={control}
            render={({ field }) => (
              <TextField
                label={'Descripción Moneda'}
                size={'small'}
                fullWidth
                onChange={field.onChange}
                value={field.value}
                helperText={errors.descripcion?.message || ''}
                error={Boolean(errors.descripcion)}
                slotProps={{
                  inputLabel: { shrink: true },
                }}
                required
              />
            )}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Controller
            name={'tipoCambio'}
            control={control}
            render={({ field }) => (
              <TextField
                label={'Tipo Cambio'}
                size={'small'}
                fullWidth
                onChange={field.onChange}
                value={field.value?.toString() || ''}
                helperText={errors.tipoCambio?.message || ''}
                error={Boolean(errors.tipoCambio)}
                slotProps={{
                  input: {
                    inputComponent: NumeroMask as any,
                    endAdornment: monedaPrimaria?.sigla || '',
                  },
                }}
                required
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Controller
            name={'tipoCambioCompra'}
            control={control}
            render={({ field }) => (
              <TextField
                label={'Tipo Cambio Compra'}
                size={'small'}
                fullWidth
                onChange={field.onChange}
                value={field.value?.toString() || ''}
                helperText={errors.tipoCambioCompra?.message || ''}
                error={Boolean(errors.tipoCambioCompra)}
                slotProps={{
                  input: {
                    inputComponent: NumeroMask as any,
                    endAdornment: monedaPrimaria?.sigla || '',
                  },
                }}
                required
              />
            )}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default MonedaForm
